import { cloneDeep } from "lodash"

const dataTemplate = {
  '患者手术综合评估建议': [
    {
      '评估结论': [
        {
          label: '脑健康风险筛查结果',
          name: 'diagnose',
          selectItems: [
            '风险为低等',
            '风险为中等',
            '风险为高等'
          ],
          type: 'select',
          inputVal: ''
        }
      ]
    }
  ],
  '大脑组织分析结果': [
    {
      '脑区分割图像':  [
        {
          name: 'Brain_Segmentation_Image',
          type: 'onlyImage',
          iamgeNum: 1,
          imageList: [
            {
              name: 'brain_segmentation_image_1',
              url: ''
            }
          ]
        }
      ],
      '脑分区图像': [
        {
          name: 'Brain_Region_Image',
          type: 'onlyImage',
          iamgeNum: 1,
          imageList: [
            {
              name: 'brain_region_image_1',
              url: ''
            }
          ]
        }
      ],
      '脑灰质图': [
        {
          name: 'Gray_Matter_Map',
          type: 'onlyImage',
          iamgeNum: 1,
          imageList: [
            {
              name: 'brain_region_image_1',
              url: ''
            }
          ]
        }
      ]
    }
  ],
  "指标分析": [
    {
      '海马体': [
        {
          label: '海马体绝对体积左侧(ml)',
          name: 'Hippocampus',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          label: '海马体绝对体积右侧(ml)',
          type: 'onlyNum',
          name: 'Hippocampus',
          inputVal: ''
        },
        {
          label: '海马体相对体积左侧(%)',
          type: 'onlyNum',
          name: 'Hippocampus',
          inputVal: ''
        },
        {
          label: '海马体相对体积右侧(%)',
          type: 'onlyNum',
          name: 'Hippocampus',
          inputVal: ''
        },
        {
          label: '海马体对称相对差异',
          type: 'onlyNum',
          name: 'Hippocampus',
          inputVal: ''
        },
        {
          label: '海马体临界值(ml)',
          type: 'onlyNum',
          name: 'Hippocampus',
          inputVal: ''
        }
      ],
      '尾状核': [
        {
          label: '尾状核绝对体积左侧(ml)',
          name: 'Caudate_Nucleus',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Caudate_Nucleus',
          label: '尾状核绝对体积右侧(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Caudate_Nucleus',
          label: '尾状核相对体积左侧(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          label: '尾状核相对体积右侧(ml)',
          name: 'Caudate_Nucleus',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Caudate_Nucleus',
          label: '尾状核相对对称相对差异(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Caudate_Nucleus',
          label: '尾状核临界值(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        
      ],
      '壳核': [
        {
          label: '壳核绝对体积左侧(ml)',
          name: 'Putamen',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Putamen',
          label: '壳核绝对体积右侧(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Putamen',
          label: '壳核相对体积左侧(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          label: '壳核相对体积右侧(ml)',
          name: 'Putamen',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Putamen',
          label: '壳核相对对称相对差异(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Putamen',
          label: '壳核临界值(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        
      ],
      '丘脑': [
        {
          label: '丘脑绝对体积左侧(ml)',
          name: 'Thalamus',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Thalamus',
          label: '丘脑绝对体积右侧(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Thalamus',
          label: '丘脑相对体积左侧(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          label: '丘脑相对体积右侧(ml)',
          name: 'Thalamus',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Thalamus',
          label: '丘脑相对对称相对差异(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Thalamus',
          label: '丘脑临界值(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        
      ],
      '中脑腹侧': [
        {
          label: '中脑腹侧绝对体积左侧(ml)',
          name: 'Ventral_Midbrain',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Ventral_Midbrain',
          label: '中脑腹侧绝对体积右侧(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Ventral_Midbrain',
          label: '中脑腹侧相对体积左侧(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          label: '中脑腹侧相对体积右侧(ml)',
          name: 'Ventral_Midbrain',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Ventral_Midbrain',
          label: '中脑腹侧相对对称相对差异(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Ventral_Midbrain',
          label: '中脑腹侧临界值(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        
      ],
      '伏隔核': [
        {
          label: '伏隔核绝对体积左侧(ml)',
          name: 'Nucleus_Accumbens',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Nucleus_Accumbens',
          label: '伏隔核绝对体积右侧(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Nucleus_Accumbens',
          label: '伏隔核相对体积左侧(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          label: '伏隔核相对体积右侧(ml)',
          name: 'Nucleus_Accumbens',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Nucleus_Accumbens',
          label: '伏隔核相对对称相对差异(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Nucleus_Accumbens',
          label: '伏隔核临界值(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        
      ],
      '苍白球': [
        {
          label: '苍白球绝对体积左侧(ml)',
          name: 'Globus_Pallidus',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Globus_Pallidus',
          label: '苍白球绝对体积右侧(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Globus_Pallidus',
          label: '苍白球相对体积左侧(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          label: '苍白球相对体积右侧(ml)',
          name: 'Globus_Pallidus',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Globus_Pallidus',
          label: '苍白球相对对称相对差异(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Globus_Pallidus',
          label: '苍白球临界值(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        
      ],
      '嗅皮质': [
        {
          label: '嗅皮质绝对体积左侧(ml)',
          name: 'Olfactory_Cortex',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Olfactory_Cortex',
          label: '嗅皮质绝对体积右侧(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Olfactory_Cortex',
          label: '嗅皮质相对体积左侧(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          label: '嗅皮质相对体积右侧(ml)',
          name: 'Olfactory_Cortex',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Olfactory_Cortex',
          label: '嗅皮质相对对称相对差异(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Olfactory_Cortex',
          label: '嗅皮质临界值(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        
      ],
      '杏仁核': [
        {
          label: '杏仁核绝对体积左侧(ml)',
          name: 'Amygdala',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Amygdala',
          label: '杏仁核绝对体积右侧(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Amygdala',
          label: '杏仁核相对体积左侧(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          label: '杏仁核相对体积右侧(ml)',
          name: 'Amygdala',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Amygdala',
          label: '杏仁核相对对称相对差异(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Amygdala',
          label: '杏仁核临界值(ml)',
          type: 'onlyNum',
          inputVal: ''
        }
      ],
      '脑干': [
        {
          label: '脑干绝对体积(ml)',
          name: 'Brainstem',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Brainstem',
          label: '脑干相对体积(ml)',
          type: 'onlyNum',
          inputVal: ''
        },
        {
          name: 'Brainstem',
          label: '脑干临界值(ml)',
          type: 'onlyNum',
          inputVal: ''
        }
      ]
    }
  ]
}

let labelMap = {
  'Olfactory_Cortex': '嗅皮质',
  'Caudate_Nucleus': '尾状核',
  'Amygdala': '杏仁核',
  'Brainstem': '脑干',
  'Thalamus': '丘脑',
  'Ventral_Midbrain': '中脑腹侧',
  'Nucleus_Accumbens': '伏隔核',
  'Putamen': '壳核',
  'Globus_Pallidus': '苍白球',
  'Hippocampus': '海马体',
}



function createParams(reportData) {
  let params = {
    detail: {},
    diagnose: '',
    Brain_Segmentation_Image: [],
    Brain_Region_Image: [],
    Gray_Matter_Map: []
  }
  params.diagnose = {
    str: reportData['患者手术综合评估建议'][0]['评估结论'][0]['inputVal'],
  }
  if (params.diagnose.str.indexOf('高') !== -1) params.diagnose.val = 1
  if (params.diagnose.str.indexOf('中') !== -1) params.diagnose.val = 2
  if (params.diagnose.str.indexOf('低') !== -1) params.diagnose.val = 3
  // 大脑组织分析结果
  params.Brain_Segmentation_Image = [reportData['大脑组织分析结果'][0]['脑区分割图像'][0]['imageList'][0]['url']]
  params.Brain_Region_Image = [reportData['大脑组织分析结果'][0]['脑分区图像'][0]['imageList'][0]['url']]
  params.Gray_Matter_Map = [reportData['大脑组织分析结果'][0]['脑灰质图'][0]['imageList'][0]['url']]
  // 指标分析
  let indexs = reportData['指标分析'][0]
  for(let key in indexs) {
    let firstObj = indexs[key][0]
    let tempObj = params.detail[firstObj.name] = {}
    let items = indexs[key]
    if (items.length === 6) {
      tempObj['modulus'] = {
        left: {
          str: `左侧：${items[0]['inputVal']}`,
          val: `${items[0].inputVal}`
        },
        right: {
          str: `右侧：${items[1]['inputVal']}`,
          val: `${items[1].inputVal}`
        }
      }
      tempObj['relative'] = {
        left: {
          str: `左侧：${items[2]['inputVal']}%`,
          val: `${items[2].inputVal}%`
        },
        right: {
          str: `右侧：${items[3]['inputVal']}%`,
          val: `${items[3].inputVal}%`
        }
      }
      tempObj['difference'] = `${items[4].inputVal}%`
      tempObj['critical_value'] = `${items[5].inputVal}`
    }
    if (items.length === 3) {
      tempObj['modulus'] = `${items[0].inputVal}`
      tempObj['relative'] = `${items[1].inputVal}`
      tempObj['difference'] = '-'
      tempObj['critical_value'] = `${items[2].inputVal}`
    }
  }
  return params
}

function parseJsonObj(jsonObj) {
  let reportData = cloneDeep(dataTemplate)
  for (let k in jsonObj) {
    let item = jsonObj[k]
    if (k === 'diagnose') {
      reportData['患者手术综合评估建议'][0]['评估结论'][0]['inputVal'] = item.str
    }
    if (k === 'Brain_Region_Image') {
      reportData['大脑组织分析结果'][0]['脑分区图像'][0]['imageList'][0]['url'] = item[0]
    } else if (k === 'Brain_Segmentation_Image') {
      reportData['大脑组织分析结果'][0]['脑区分割图像'][0]['imageList'][0]['url'] = item[0]
    } else if (k === 'Gray_Matter_Map') {
      reportData['大脑组织分析结果'][0]['脑灰质图'][0]['imageList'][0]['url'] = item[0]
    } 
    if (k === 'detail') {
      for(let key in item) {
        let label = labelMap[key]
        let detailItem = item[key]
        let destObj = reportData['指标分析'][0][label]
        if (label === '脑干') {
          destObj[0]['inputVal'] = detailItem.modulus
          destObj[1]['inputVal'] = detailItem.relative.replace("%", '')
          destObj[2]['inputVal'] = detailItem.critical_value
        } else {
          console.log('relative', detailItem.relative)
          destObj[0]['inputVal'] = detailItem.modulus.left.val
          destObj[1]['inputVal'] = detailItem.modulus.right.val
          destObj[2]['inputVal'] = detailItem.relative.left.val.replace("%", '')
          destObj[3]['inputVal'] = detailItem.relative.right.val.replace("%", '')
          destObj[4]['inputVal'] = detailItem.difference.replace("%", '')
          destObj[5]['inputVal'] = detailItem.critical_value
        }
      }
    }
  }
  console.log('解析后的', reportData)
  return reportData
}



export default {dataTemplate, createParams, parseJsonObj, reportType: 'BHM'}